import { IconWrapper } from '../runtime';
export default IconWrapper('folder-company-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.75 20.25C1.50736 20.25 0.5 19.2426 0.5 18L0.5 3C0.5 1.75736 1.50736 0.75 2.75 0.75L7.25 0.75C7.73683 0.75 8.21053 0.9079 8.6 1.2L10.4 2.55C10.7895 2.8421 11.2632 3 11.75 3L22.25 3C23.4926 3 24.5 4.00736 24.5 5.25L24.5 18C24.5 19.2426 23.4926 20.25 22.25 20.25L2.75 20.25Z",
      "fill": "#317FF2"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.75 22.5C1.50736 22.5 0.5 21.4926 0.5 20.25L0.5 7.5C0.5 6.25736 1.50736 5.25 2.75 5.25L22.25 5.25C23.4926 5.25 24.5 6.25736 24.5 7.5L24.5 20.25C24.5 21.4926 23.4926 22.5 22.25 22.5L2.75 22.5Z",
      "fill": 'url(#' + props.id + '756632b1' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "M8 11.1136C8 10.6341 8.3039 10.2073 8.757 10.0504L12.1285 8.88339C12.4939 8.75691 12.875 9.02828 12.875 9.41494V17.8125H8.75C8.33579 17.8125 8 17.4767 8 17.0625V11.1136Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M17 12.9709C17 12.6073 16.7897 12.2764 16.4604 12.1221L14.8012 11.3443C14.4282 11.1695 14 11.4417 14 11.8536V17.8125H16.25C16.6642 17.8125 17 17.4767 17 17.0625V12.9709Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '756632b1',
      "x1": "2.75",
      "y1": "6.43828",
      "x2": "19.6823",
      "y2": "24.658",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});